import type { ChaocEvent } from '../contracts/events';

export type PublicDataStatus = 'loading' | 'ready' | 'empty' | 'unavailable' | 'fixture';

interface ResolvePublicEventsOptions {
  requestSucceeded: boolean;
  liveEvents: ChaocEvent[];
  fixtures: ChaocEvent[];
  fixturesEnabled: boolean;
  failureMessage?: string;
}

interface PublicEventsResolution {
  events: ChaocEvent[];
  status: Exclude<PublicDataStatus, 'loading'>;
  message: string | null;
}

const PUBLIC_DATA_STATUS_LABELS: Record<PublicDataStatus, string> = {
  loading: 'LOADING PUBLIC',
  ready: 'LIVE PUBLIC',
  empty: 'NO LIVE EVENTS',
  unavailable: 'PUBLIC DATA UNAVAILABLE',
  fixture: 'DEV FIXTURE',
};

export function resolvePublicEvents({
  requestSucceeded,
  liveEvents,
  fixtures,
  fixturesEnabled,
  failureMessage,
}: ResolvePublicEventsOptions): PublicEventsResolution {
  if (requestSucceeded && liveEvents.length > 0) {
    return {
      events: liveEvents,
      status: 'ready',
      message: null,
    };
  }

  if (fixturesEnabled && fixtures.length > 0) {
    return {
      events: fixtures,
      status: 'fixture',
      message: requestSucceeded
        ? 'Development fixtures shown because the public feed returned no events'
        : 'Development fixtures shown because public events are unavailable',
    };
  }

  if (requestSucceeded) {
    return {
      events: [],
      status: 'empty',
      message: 'Public feed returned no events',
    };
  }

  return {
    events: [],
    status: 'unavailable',
    message: failureMessage || 'Public events unavailable',
  };
}

export function publicDataStatusLabel(status: PublicDataStatus): string {
  return PUBLIC_DATA_STATUS_LABELS[status];
}
